import React from 'react';

/** "Check" glyph from the Backoffice design system (System & Devices), exported from Figma node 26828:59301. */
const IconCheckFilled: React.FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M21.5306 7.28063L9.53063 19.2806C9.46097 19.3504 9.37825 19.4057 9.28721 19.4434C9.19616 19.4812 9.09856 19.5006 9 19.5006C8.90144 19.5006 8.80384 19.4812 8.71279 19.4434C8.62175 19.4057 8.53903 19.3504 8.46937 19.2806L3.21938 14.0306C3.07864 13.8899 2.99958 13.699 2.99958 13.5C2.99958 13.301 3.07864 13.1101 3.21938 12.9694C3.36011 12.8286 3.55098 12.7496 3.75 12.7496C3.94902 12.7496 4.13989 12.8286 4.28062 12.9694L9 17.6897L20.4694 6.21937C20.6101 6.07864 20.801 5.99958 21 5.99958C21.199 5.99958 21.3899 6.07864 21.5306 6.21937C21.6714 6.36011 21.7504 6.55098 21.7504 6.75C21.7504 6.94902 21.6714 7.1399 21.5306 7.28063Z"
      fill="currentColor"
    />
  </svg>
);

export default IconCheckFilled;
